import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';
import { currencyShape, priceInfoShape } from '../../constants/PropTypes';
import { getDisplayMode } from '../../shared/utils/UtilsHelper';
import FormattedPrice from 'Components/Language/FormattedPrice';

function CardPrice(props) {

    const {
        priceInfo, className, currencyDisplay, currency, showPrices,
        country, language, availableDaterange, priceDisplayMode,
    } = props;
    const { price, originalPrice } = priceInfo;
    if (!showPrices || price === 0) {
        return <div />;
    }

    return (
        <div className={`kbe-card-price-wrapper ${className}`}>
            {
                price ?
                    <small className="kbe-card-price-from-tag text-muted">
                        <FormattedMessage id="bf.startingFrom" defaultMessage="bf.startingFrom" />
                    </small>
                    : null
            }

            {
                originalPrice ?
                    <div className="kbe-card-original-price-wrapper">
                        <span className="kbe-card-original-price">
                            {currency.code}
                            {' '}
                            {originalPrice}
                        </span>
                    </div>
                    : null
            }

            {
                price ?
                    (
                        <div className={`${availableDaterange ? 'kbe-card-dateRange-and-price' : 'kbe-card-price'}`}>
                            {availableDaterange ? <FormattedMessage
                                id="bf.availableDaterange"
                                defaultMessage="bf.availableDaterange"
                                values={{
                                    start: moment(availableDaterange.start).format('MMM DD'),
                                    end: moment(availableDaterange.end).format('MMM DD'),
                                }}
                            /> : null}
                            <FormattedPrice
                                price={price}
                                currency={currency}
                                currencyDisplay={currencyDisplay}
                                country={country}
                                language={language}
                            />
                        </div>
                    )
                    : ''
            }
            {
                price && priceDisplayMode
                    ? <small className="kbe-card-price-reference text-muted">
                        {
                            getDisplayMode(priceDisplayMode)
                        }
                    </small>
                    : null
            }
        </div>
    );
}

CardPrice.defaultProps = { className: '', showPrices: true };

CardPrice.propTypes = {
    className: PropTypes.string,
    priceInfo: PropTypes.shape(priceInfoShape).isRequired,
    currencyDisplay: PropTypes.string.isRequired,
    currency: PropTypes.shape(currencyShape).isRequired,
    showPrices: PropTypes.bool,
    country: PropTypes.string.isRequired,
    language: PropTypes.string.isRequired,
    availableDaterange: PropTypes.shape({ start: PropTypes.string, end: PropTypes.string }),
    priceDisplayMode: PropTypes.string,
};

export default CardPrice;
